import type { FaireProductEntity } from "../../entity_types/product";

export const p_m4ebrv7g7m: FaireProductEntity = {
  token: "p_m4ebrv7g7m",
  type: "product",
  name: "Helium 21 Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/55dbbfe9eec5520839a6314cc697796e7e0d96a5fd7fc94f3b2350acd4b9e9bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/504a1a88ccdcc26a8f204c1549267e084d0af6218edf84a6be9c1c9b16fff22c.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "Spread joy and laughter on your loved one's special day with our Helium 21 Birthday Greeting Card. Imprinted with the fun message 'Hope your birthday makes you feel floaty!' this card exudes pure positivity. Crafted by E. Frances Paper, known for creating nostalgic and connection-driven illustrations, this card adds an extra personal touch to your birthday wishes. It's more than just a card, it's a gift of joy and love. Based in Newport, RI, we at E. Frances Paper are all about spreading happiness with every card we create.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:27.914Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
